import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { tanimlarApi } from '../services/api';
import DataTable, { DtColumn } from '../components/DataTable';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });
const YIL = new Date().getFullYear();
const AYLAR = ['', 'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
               'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];

const emptyForm = {
  isletme_id: '', yil: YIL, ay: 12, silo_ton: 0, hangar_m2: 0, yem_ambar_m3: 0,
  malzeme_ambar_m3: 0, akaryakit_tanki_m3: 0, tohum_hazirlama_ton_saat: 0,
  misir_kurutma_ton_saat: 0, yem_hazirlama_ton_saat: 0,
  sagim_ahiri_bas: 0, besilik_ahiri_bas: 0, dana_ahiri_bas: 0,
  buzagi_ahiri_bas: 0, duve_ahiri_bas: 0, ana_koyun_agili_bas: 0,
  kuzu_oglak_agili_bas: 0, koc_teke_agili_bas: 0,
  kisrak_tavlasi_bas: 0, tay_tavlasi_bas: 0, aygir_tavlasi_bas: 0, aciklama: ''
};

export default function TesisVarligi() {
  const [kayitlar,   setKayitlar]   = useState<any[]>([]);
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [modalAcik,  setModalAcik]  = useState(false);
  const [form,       setForm]       = useState<any>({ ...emptyForm });
  const [filtre,     setFiltre]     = useState((() => {
    const sp = new URLSearchParams(window.location.search);
    return {
      isletme_id: sp.get('isletme') || '',
      yil: Number(sp.get('yil') || YIL),
      ay: sp.get('ay') || ''
    };
  })());
  const [hata,       setHata]       = useState('');
  const [yukleniyor, setYukleniyor] = useState(false);

  const userStr = localStorage.getItem('user');
  const user    = userStr ? JSON.parse(userStr) : null;
  const isGM    = user?.rol && ['super_admin','gm_yonetici','gm_personel'].includes(user.rol);
  const isAdmin = user?.rol && ['super_admin','gm_yonetici'].includes(user.rol);

  const [kiralikGoster, setKiralikGoster] = useState(false);

  useEffect(() => {
    if (!isGM && user?.isletme_id) setFiltre(f => ({ ...f, isletme_id: user.isletme_id }));
  }, []);

  useEffect(() => {
    tanimlarApi.isletmelerListesi(kiralikGoster).then(r => setIsletmeler(r.data));
  }, [kiralikGoster]);

  useEffect(() => { yukle(); }, [filtre]);

  const yukle = () => {
    const p: any = { yil: filtre.yil };
    if (filtre.isletme_id) p.isletme_id = filtre.isletme_id;
    if (filtre.ay) p.ay = Number(filtre.ay);
    axios.get(`${API}/api/varlik/tesis`, { headers: headers(), params: p }).then(r => setKayitlar(r.data)).catch(() => setKayitlar([]));
  };

  const mevcuduYukle = async (isletme_id: any, yil: number) => {
    if (!isletme_id) return;
    try {
      const r = await axios.get(`${API}/api/varlik/tesis`, { headers: headers(), params: { isletme_id, yil } });
      const mevcut = r.data?.[0];
      if (mevcut) setForm({ ...mevcut });
    } catch {}
  };

  const kaydet = async () => {
    if (!form.isletme_id) { setHata('İşletme seçiniz'); return; }
    setHata(''); setYukleniyor(true);
    try {
      if (form.id) {
        await axios.put(`${API}/api/varlik/tesis/${form.id}`, { ...form, isletme_id: Number(form.isletme_id) }, { headers: headers() });
      } else {
        await axios.post(`${API}/api/varlik/tesis`, { ...form, isletme_id: Number(form.isletme_id) }, { headers: headers() });
      }
      yukle(); setModalAcik(false); setForm({ ...emptyForm });
    } catch (e: any) { setHata(e.response?.data?.detail || 'Hata oluştu'); }
    finally { setYukleniyor(false); }
  };

  const sil = async (id: number) => {
    if (!window.confirm('Silmek istiyor musunuz?')) return;
    try { await axios.delete(`${API}/api/varlik/tesis/${id}`, { headers: headers() }); yukle(); } catch {}
  };

  const silSecili = async (rows: any[]) => {
    for (const k of rows) await axios.delete(`${API}/api/varlik/tesis/${k.id}`, { headers: headers() });
    yukle();
  };

  const n = (v: any) => Number(v || 0).toLocaleString('tr-TR');
  const f = (v: any) => Number(v || 0).toLocaleString('tr-TR', { maximumFractionDigits: 1 });

  const tesisColumns: DtColumn[] = [
    { key: 'isletme', label: 'İşletme', sortable: true, filterable: true, render: (k: any) => <><strong>{k.isletme_kod}</strong><br /><small>{k.isletme_ad}</small></>, sortValue: (k: any) => k.isletme_kod || '', filterValue: (k: any) => k.isletme_ad || '', exportValue: (k: any) => `${k.isletme_kod} ${k.isletme_ad}` },
    { key: 'yil', label: 'Yıl', sortable: true, filterable: true, sortValue: (k: any) => Number(k.yil), filterValue: (k: any) => String(k.yil) },
    { key: 'ay', label: 'Ay', sortable: true, filterable: true, render: (k: any) => AYLAR[k.ay] || k.ay, filterValue: (k: any) => AYLAR[k.ay] || String(k.ay), sortValue: (k: any) => Number(k.ay) },
    { key: 'silo_ton', label: 'Silo (ton)', sortable: true, render: (k: any) => n(k.silo_ton), sortValue: (k: any) => Number(k.silo_ton || 0) },
    { key: 'hangar_m2', label: 'Hangar (m²)', sortable: true, render: (k: any) => n(k.hangar_m2), sortValue: (k: any) => Number(k.hangar_m2 || 0) },
    { key: 'yem_ambar_m3', label: 'Yem Ambar', sortable: true, render: (k: any) => n(k.yem_ambar_m3), sortValue: (k: any) => Number(k.yem_ambar_m3 || 0) },
    { key: 'malzeme_ambar_m3', label: 'Malz. Ambar', sortable: true, render: (k: any) => n(k.malzeme_ambar_m3), sortValue: (k: any) => Number(k.malzeme_ambar_m3 || 0) },
    { key: 'akaryakit_tanki_m3', label: 'Akaryakıt (m³)', sortable: true, render: (k: any) => n(k.akaryakit_tanki_m3), sortValue: (k: any) => Number(k.akaryakit_tanki_m3 || 0) },
    { key: 'tohum_hazirlama_ton_saat', label: 'Tohum Haz.', sortable: true, render: (k: any) => f(k.tohum_hazirlama_ton_saat), sortValue: (k: any) => Number(k.tohum_hazirlama_ton_saat || 0) },
    { key: 'misir_kurutma_ton_saat', label: 'Mısır Kurt.', sortable: true, render: (k: any) => f(k.misir_kurutma_ton_saat), sortValue: (k: any) => Number(k.misir_kurutma_ton_saat || 0) },
    { key: 'sagim_ahiri_bas', label: 'Sağım Ahırı', sortable: true, render: (k: any) => n(k.sagim_ahiri_bas), sortValue: (k: any) => Number(k.sagim_ahiri_bas || 0) },
    { key: 'besilik_ahiri_bas', label: 'Besilik Ahırı', sortable: true, render: (k: any) => n(k.besilik_ahiri_bas), sortValue: (k: any) => Number(k.besilik_ahiri_bas || 0) },
    { key: 'dana_ahiri_bas', label: 'Dana Ahırı', sortable: true, render: (k: any) => n(k.dana_ahiri_bas), sortValue: (k: any) => Number(k.dana_ahiri_bas || 0) },
    { key: 'kisrak_tavlasi_bas', label: 'Kısrak Tavlası', sortable: true, render: (k: any) => n(k.kisrak_tavlasi_bas), sortValue: (k: any) => Number(k.kisrak_tavlasi_bas || 0) },
    { key: 'tay_tavlasi_bas', label: 'Tay Tavlası', sortable: true, render: (k: any) => n(k.tay_tavlasi_bas), sortValue: (k: any) => Number(k.tay_tavlasi_bas || 0) },
    { key: 'islem', label: 'İşlem', noExport: true, render: (k: any) => (
      <div style={{ display: 'flex', gap: 4 }}>
        {isAdmin && <button className="btn btn-primary btn-sm" onClick={() => { setForm({ ...k }); setHata(''); setModalAcik(true); }}>Düzenle</button>}
        <button className="btn btn-danger btn-sm" onClick={() => sil(k.id)}>Sil</button>
      </div>
    )},
  ];

  const ozet = React.useMemo(() => {
    const s = (fld: string) => kayitlar.reduce((acc, k) => acc + (k[fld] || 0), 0);
    return {
      silo_ton:                s('silo_ton'),
      hangar_m2:               s('hangar_m2'),
      buyukbas_barinagi:       s('toplam_buyukbas_barinagi'),
      kucukbas_barinagi:       s('toplam_kucukbas_barinagi'),
      tohum_hazirlama:         s('tohum_hazirlama_ton_saat'),
      yem_hazirlama:           s('yem_hazirlama_ton_saat'),
    };
  }, [kayitlar]);

  const inp = (field: string) => ({
    className: "form-control", type: "number" as const, value: form[field],
    onChange: (e: any) => setForm({ ...form, [field]: Number(e.target.value) })
  });

  return (
    <div>
      <div className="page-header">
        <h1>🏗️ Tesis & Altyapı</h1>
        <p>İşletme bazında yıllık tesis ve altyapı varlığı verileri</p>
      </div>

      {kayitlar.length > 0 && (
        <div className="stats-grid" style={{ marginBottom: 16 }}>
          <div className="stat-card"><div className="stat-icon">🏛️</div><div><div className="stat-value">{n(ozet.silo_ton)}</div><div className="stat-label">Silo (ton)</div></div></div>
          <div className="stat-card"><div className="stat-icon">🏠</div><div><div className="stat-value">{n(ozet.hangar_m2)}</div><div className="stat-label">Hangar (m²)</div></div></div>
          <div className="stat-card"><div className="stat-icon">🐄</div><div><div className="stat-value">{n(ozet.buyukbas_barinagi)}</div><div className="stat-label">Büyükbaş Barınak (baş)</div></div></div>
          <div className="stat-card"><div className="stat-icon">🐑</div><div><div className="stat-value">{n(ozet.kucukbas_barinagi)}</div><div className="stat-label">Küçükbaş Barınak (baş)</div></div></div>
          <div className="stat-card"><div className="stat-icon">🌾</div><div><div className="stat-value">{f(ozet.tohum_hazirlama)}</div><div className="stat-label">Tohum Hazırlama (t/s)</div></div></div>
          <div className="stat-card"><div className="stat-icon">🌿</div><div><div className="stat-value">{f(ozet.yem_hazirlama)}</div><div className="stat-label">Yem Hazırlama (t/s)</div></div></div>
        </div>
      )}

      <div className="card">
        <div className="toolbar">
          <div style={{ display: 'flex', gap: 8 }}>
            <input type="number" className="search-input" style={{ width: 90 }} value={filtre.yil}
              onChange={e => setFiltre({ ...filtre, yil: Number(e.target.value) })} placeholder="Yıl" />
            <select className="search-input" style={{ width: 120 }} value={filtre.ay}
              onChange={e => setFiltre({ ...filtre, ay: e.target.value })}>
              <option value="">Tüm Aylar</option>
              {AYLAR.slice(1).map((a, i) => <option key={i + 1} value={i + 1}>{a}</option>)}
            </select>
            {isGM && (
              <>
                <select className="search-input" style={{ width: 210 }} value={filtre.isletme_id}
                  onChange={e => setFiltre({ ...filtre, isletme_id: e.target.value })}>
                  <option value="">Tüm İşletmeler</option>
                  {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                </select>
                <label style={{ display:'flex', alignItems:'center', gap:4, fontSize:13, cursor:'pointer', whiteSpace:'nowrap' }}>
                  <input type="checkbox" checked={kiralikGoster} onChange={e => setKiralikGoster(e.target.checked)} />
                  Kiralıkları Göster
                </label>
              </>
            )}
          </div>
          <button className="btn btn-success" onClick={() => { setForm({ ...emptyForm, isletme_id: isGM ? '' : user?.isletme_id }); setHata(''); setModalAcik(true); }}>+ Yeni Kayıt</button>
        </div>
        <DataTable columns={tesisColumns} data={kayitlar} rowKey={(k: any) => k.id} onDeleteSelected={silSecili} exportFilename="tesis-altyapi" />
      </div>

      {modalAcik && (
        <div className="modal-overlay" onClick={() => setModalAcik(false)}>
          <div className="modal" style={{ width: 600, maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
            <div className="modal-header"><h3>🏗️ Tesis Varlığı Kayıt Girişi</h3><button className="modal-close" onClick={() => setModalAcik(false)}>×</button></div>
            <div className="modal-body">
              {hata && <div className="alert alert-danger">{hata}</div>}
              <div className="form-row">
                {isGM && (
                  <div className="form-group"><label>İşletme *</label>
                    <select className="form-control" value={form.isletme_id} onChange={e => {
                      const yeniId = e.target.value;
                      setForm({ ...emptyForm, isletme_id: yeniId, yil: form.yil });
                      mevcuduYukle(yeniId, form.yil);
                    }}>
                      <option value="">Seçiniz</option>
                      {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                    </select>
                  </div>
                )}
                <div className="form-group"><label>Yıl *</label><input className="form-control" type="number" value={form.yil} onChange={e => {
                  const yeniYil = Number(e.target.value);
                  setForm({ ...emptyForm, isletme_id: form.isletme_id, yil: yeniYil, ay: form.ay });
                  mevcuduYukle(form.isletme_id, yeniYil);
                }} /></div>
                <div className="form-group"><label>Ay *</label>
                  <select className="form-control" value={form.ay} onChange={e => setForm({ ...form, ay: Number(e.target.value) })}>
                    {AYLAR.slice(1).map((a, i) => <option key={i + 1} value={i + 1}>{a}</option>)}
                  </select>
                </div>
              </div>
              <p style={{ fontWeight: 'bold', fontSize: 13, color: '#1a5276', margin: '8px 0 6px' }}>🏗️ Depolama Tesisleri</p>
              <div className="form-row">
                <div className="form-group"><label>Silo (ton)</label><input {...inp('silo_ton')} /></div>
                <div className="form-group"><label>Hangar (m²)</label><input {...inp('hangar_m2')} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Yem Ambarı (m³)</label><input {...inp('yem_ambar_m3')} /></div>
                <div className="form-group"><label>Malzeme Ambarı (m³)</label><input {...inp('malzeme_ambar_m3')} /></div>
              </div>
              <div className="form-group"><label>Akaryakıt Tankı (m³)</label><input {...inp('akaryakit_tanki_m3')} /></div>
              <p style={{ fontWeight: 'bold', fontSize: 13, color: '#1a5276', margin: '8px 0 6px' }}>⚙️ Üretim Tesisleri</p>
              <div className="form-row">
                <div className="form-group"><label>Tohum Hazırlama (ton/saat)</label><input {...inp('tohum_hazirlama_ton_saat')} /></div>
                <div className="form-group"><label>Mısır Kurutma (ton/saat)</label><input {...inp('misir_kurutma_ton_saat')} /></div>
              </div>
              <div className="form-group"><label>Yem Hazırlama (ton/saat)</label><input {...inp('yem_hazirlama_ton_saat')} /></div>
              <p style={{ fontWeight: 'bold', fontSize: 13, color: '#1a5276', margin: '8px 0 6px' }}>🐄 Büyükbaş Barınakları (Ahır)</p>
              <div className="form-row">
                <div className="form-group"><label>Sağım Ahırı (Baş)</label><input {...inp('sagim_ahiri_bas')} /></div>
                <div className="form-group"><label>Besilik Ahırı (Baş)</label><input {...inp('besilik_ahiri_bas')} /></div>
              </div>
              <div className="form-row">
                <div className="form-group"><label>Dana Ahırı (Baş)</label><input {...inp('dana_ahiri_bas')} /></div>
                <div className="form-group"><label>Buzağı Ahırı (Baş)</label><input {...inp('buzagi_ahiri_bas')} /></div>
              </div>
              <div className="form-group"><label>Düve Ahırı (Baş)</label><input {...inp('duve_ahiri_bas')} /></div>
              <p style={{ fontWeight: 'bold', fontSize: 13, color: '#1a5276', margin: '8px 0 6px' }}>🐑 Küçükbaş Barınakları (Ağıl)</p>
              <div className="form-row">
                <div className="form-group"><label>Ana Koyun/Keçi Ağılı (Baş)</label><input {...inp('ana_koyun_agili_bas')} /></div>
                <div className="form-group"><label>Kuzu/Oğlak Ağılı (Baş)</label><input {...inp('kuzu_oglak_agili_bas')} /></div>
              </div>
              <div className="form-group"><label>Koç/Teke Ağılı (Baş)</label><input {...inp('koc_teke_agili_bas')} /></div>
              <p style={{ fontWeight: 'bold', fontSize: 13, color: '#1a5276', margin: '8px 0 6px' }}>🐎 At Barınakları (Tavla)</p>
              <div className="form-row">
                <div className="form-group"><label>Kısrak Tavlası (Baş)</label><input {...inp('kisrak_tavlasi_bas')} /></div>
                <div className="form-group"><label>Tay Tavlası (Baş)</label><input {...inp('tay_tavlasi_bas')} /></div>
              </div>
              <div className="form-group"><label>Aygır Tavlası (Baş)</label><input {...inp('aygir_tavlasi_bas')} /></div>
              <div className="form-group" style={{ marginTop: 8 }}><label>Açıklama</label><textarea className="form-control" value={form.aciklama} onChange={e => setForm({ ...form, aciklama: e.target.value })} rows={2} /></div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={() => setModalAcik(false)} style={{ background: '#eee' }}>İptal</button>
              <button className="btn btn-primary" onClick={kaydet} disabled={yukleniyor}>{yukleniyor ? 'Kaydediliyor...' : 'Kaydet'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
